import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.03 7.03C0 14.058 0 25.372 0 48v4c0 22.627 0 33.941 7.03 40.97C14.058 100 25.372 100 48 100h4c22.627 0 33.941 0 40.97-7.03C100 85.942 100 74.628 100 52v-4c0-22.627 0-33.941-7.03-40.97C85.942 0 74.628 0 52 0h-4C25.373 0 14.059 0 7.03 7.03Zm9.845 23.387c.542 26 13.542 41.625 36.333 41.625H54.5V57.167c8.375.833 14.708 6.958 17.25 14.875h11.834c-3.25-11.834-11.793-18.375-17.126-20.875 5.333-3.084 12.834-10.584 14.625-20.75h-10.75c-2.334 8.25-9.25 15.75-15.833 16.458V30.417H43.75V59.25c-6.667-1.666-15.083-9.75-15.458-28.833H16.875Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }